// extracted by mini-css-extract-plugin
export default {"Divider":"peacegame_Divider_Divider"};